import React from 'react';
import { Lock } from 'lucide-react';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';

/**
 * Locked main-content notice for a non-owner member of a Free-plan workspace.
 *
 * On Free (a single-seat plan) we keep extra members on the team but lock them
 * out of the dashboard until the owner upgrades (spec 2.5.6). This renders inside
 * MainLayout, so the sidebar stays put — the member can still switch workspaces or
 * sign out from the sidebar account menu, the same as an expired subscription.
 */
const SeatLocked = () => {
  const { seller } = useAuth();

  const storeName = seller?.displayName || seller?.name || 'this workspace';

  return (
    <div className="flex min-h-[70vh] items-center justify-center p-6">
      <div className="w-full max-w-md rounded-xl border border-gray-200 dark:border-border bg-white dark:bg-background p-8 text-center shadow-sm">
        <div className="mx-auto flex size-11 items-center justify-center rounded-full bg-gray-100 dark:bg-muted">
          <Lock
            className="size-5 text-gray-500 dark:text-muted-foreground"
            strokeWidth={1.75}
            aria-hidden="true"
          />
        </div>

        <h1 className="mt-5 text-xl font-semibold text-gray-900 dark:text-foreground">
          This workspace is on the Free plan
        </h1>

        <p className="mt-2 text-sm leading-relaxed text-gray-600 dark:text-muted-foreground">
          The Free plan includes one team member, so only the owner of{' '}
          <span className="font-medium text-gray-900 dark:text-foreground">{storeName}</span> can
          use the dashboard right now. Ask them to upgrade to restore your access.
        </p>
      </div>
    </div>
  );
};

export default SeatLocked;
